import React, { Fragment } from "react";
import StarsIcon from "@mui/icons-material/Stars";
import styled from "@emotion/styled";
import { Theme, Typography } from "@mui/material";
import { css } from "@emotion/react";

const Container = styled.div<{ spacing: number }>`
  display: flex;
  & > :not(style) {
    ${({ spacing, theme }) => `margin-right: ${theme.spacing(spacing)}`};
  }
`;

const round = (theme: Theme) => css`
  background-color: ${theme.palette.text.primary};
  color: white;
`;

const NumberRating = styled(Typography)<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  ${({ selected, theme }) => (selected ? round(theme) : "")}
`;

export interface RatingProps {
  variant?: "stars" | "numbers";
  rating?: number;
  max?: number;
}

export const Rating = ({
  rating = 0,
  max = 5,
  variant = "stars",
}: RatingProps) => {
  return (
    <Container spacing={variant === "stars" ? 0 : 1}>
      {Array.from({ length: max }, (v, i) => i + 1).map((r) => (
        <Fragment key={`rank-${r}`}>
          {variant === "stars" && (
            <StarsIcon color={rating >= r ? "inherit" : "disabled"} />
          )}
          {variant === "numbers" && (
            <NumberRating variant="h5" selected={r === rating}>
              {r}
            </NumberRating>
          )}
        </Fragment>
      ))}
    </Container>
  );
};
